import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import moment from "moment";
import Table from "material-ui/Table";
import { TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableHead } from "material-ui/Table";
import { TableRow } from "material-ui/Table";

import { withStyles } from "material-ui/styles";
import styles from "./headerinfostyles"
import { infoData } from "./infoenum"

class HeaderInfo extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      classes,
      result,
      subtest,
      subtestSubTestSettingsResults,
      translate
    } = this.props;

    return (
      <Grid container style={{ marginTop: '30px' }}>
        <Grid item xs={2} />
        <Grid item xs={2} className={classes.totalGrid}>
          <Typography color="inherit" className={classes.defaultText}>
            {translate("result_test_started")}
          </Typography>
          <Typography color="inherit" className={classes.defaultText}>
            {subtestSubTestSettingsResults.teststarted
              ? moment(subtestSubTestSettingsResults.teststarted).format(
                "DD/MM/YYYY HH:mm:ss"
              )
              : ""}
          </Typography>
        </Grid>
        <Grid item xs={2} className={classes.totalGrid}>
          <Typography className={classes.defaultText} color="inherit">
            {translate("result_test_duration")}
          </Typography>
          <Typography className={classes.defaultText} color="inherit">
            {subtestSubTestSettingsResults.testduration
              ? subtestSubTestSettingsResults.testduration
              : ""}
          </Typography>
        </Grid>
        <Grid item xs={2} className={classes.totalGrid}>
          <Typography className={classes.defaultText} color="inherit">
            {translate("sub_test_link_speed").toUpperCase()}
          </Typography>
          <Typography className={classes.defaultText} color="inherit">
            {subtestSubTestSettingsResults.linkspeed
              ? subtestSubTestSettingsResults.linkspeed + 'b/s'
              : ""}
          </Typography>
        </Grid>
        <Grid item xs={2} className={classes.totalGridLast}>
          <Typography className={classes.defaultText} color="inherit" style={{ marginLeft: '7px'}}>
            {translate("result_info_status")}
          </Typography>
          <Typography className={classes.defaultText} color="inherit">
            <React.Fragment className={classes.pass}>
              <div className={classes.infoHead}>
                {subtestSubTestSettingsResults.subteststatus.toLowerCase() ==
                  "passed" ? (
                    <Icon className={classes.passState}>check_circle</Icon>
                  ) : (
                    <Icon className={classes.failState}>cancel</Icon>
                  )}
                  <div className={classes.infoText}>
                      {infoData.find(
                        o =>
                          o.name === subtestSubTestSettingsResults.info
                      )
                        ? " " +
                          translate(
                            infoData.find(
                              o =>
                                o.name ===
                                subtestSubTestSettingsResults.info
                            ).id
                          )
                        : ""}
                    </div>
              </div>
            </React.Fragment>
          </Typography>
        </Grid>
        <Grid item xs={2} />
      </Grid>
    )
  }
}

export default withStyles(styles)(HeaderInfo);



// WEBPACK FOOTER //
// ./src/components/common/results/views/subtestsettings/common/headerinfo.js